import { DateTime } from 'luxon'

import {
  PAYMENT_ACTION_REQUEST_ANSWER_DELAY_IN_HOURS,
  PAYMENT_ACTION_REQUEST_STATUS_CONFIRMED,
  PAYMENT_ACTION_REQUEST_STATUS_NO_ANSWER,
  PAYMENT_ACTION_REQUEST_STATUS_PENDING,
  PAYMENT_ACTION_REQUEST_STATUS_REFUSED,
  PAYMENT_ACTION_REQUEST_STATUS_SEND_FAILED,
  PAYMENT_ACTION_REQUEST_SUFFIX,
  PAYMENT_ACTION_STATUS_ERROR,
  PAYMENT_ACTION_STATUS_SUCCESS,
} from '../config/paymentActions'

const isPaymentActionRequest = (paymentAction) => !!paymentAction?.action?.endsWith(PAYMENT_ACTION_REQUEST_SUFFIX)

const findRequestAnswer = (request, paymentActions) => {
  const answerAction = request.action.slice(0, -PAYMENT_ACTION_REQUEST_SUFFIX.length)
  return paymentActions.find(
    (paymentAction) => paymentAction.action === answerAction && paymentAction.psp_reference === request.psp_reference,
  )
}

const hasAnswerDelayElapsed = (request) =>
  DateTime.now().diff(DateTime.fromISO(request.created_on), 'hours').hours >=
  PAYMENT_ACTION_REQUEST_ANSWER_DELAY_IN_HOURS

const getRequestDisplay = (request, answer) => {
  if (request.status === PAYMENT_ACTION_STATUS_ERROR) {
    return { status: PAYMENT_ACTION_REQUEST_STATUS_SEND_FAILED, refusalReason: request.refusal_reason }
  }
  if (answer?.status === PAYMENT_ACTION_STATUS_SUCCESS) {
    return { status: PAYMENT_ACTION_REQUEST_STATUS_CONFIRMED, refusalReason: request.refusal_reason }
  }
  if (answer?.status === PAYMENT_ACTION_STATUS_ERROR) {
    return { status: PAYMENT_ACTION_REQUEST_STATUS_REFUSED, refusalReason: answer.refusal_reason }
  }
  const status = hasAnswerDelayElapsed(request)
    ? PAYMENT_ACTION_REQUEST_STATUS_NO_ANSWER
    : PAYMENT_ACTION_REQUEST_STATUS_PENDING
  return { status, refusalReason: request.refusal_reason }
}

export const getPaymentActionDisplay = (paymentAction, paymentActions) => {
  if (!isPaymentActionRequest(paymentAction)) {
    return { status: paymentAction.status, refusalReason: paymentAction.refusal_reason }
  }
  const answer = findRequestAnswer(paymentAction, paymentActions)
  return getRequestDisplay(paymentAction, answer)
}
